import React from 'react';
import Card3 from '../components/Card3';
import Card4 from '../components/Card4';
import Card5 from '../components/Card5';
import Card6 from '../components/Card6';
import Card7 from '../components/Card7';
import Card8 from '../components/Card8';
import Card9 from '../components/Card9';
import Graph5 from '../components/Graph5';

// ── Largeur commune : de la 1re carte (220px) au bord droit de la 4e carte ──
const CONTENT_LEFT  = '220px';
const CONTENT_WIDTH = 970;



// ── Séparateur de section ─────────────────────────────────────────
const SectionLabel = ({ label, top, left = CONTENT_LEFT, width = `${CONTENT_WIDTH}px` }) => (
  <div style={{
    position: 'absolute', top, left, width,
    display: 'flex', alignItems: 'center', gap: '14px',
  }}>
    <div style={{ flex: 1, height: '1px', background: '#e9ecef' }} />
    <span style={{
      fontSize: '11px', fontWeight: 700, letterSpacing: '2px',
      textTransform: 'uppercase', color: '#6c757d',
      whiteSpace: 'nowrap',
    }}>
      {label}
    </span>
    <div style={{ flex: 1, height: '1px', background: '#e9ecef' }} />
  </div>
);

const Home = () => {
  return (
    <div style={{
      fontFamily: "'Segoe UI', sans-serif",
      position: 'relative',
      minHeight: '920px',
      padding: '0 0 40px 0',
    }}>

      {/* ════════════════════════════════
          SECTION — VENTES
      ════════════════════════════════ */}
      <SectionLabel label="Ventes" top="30px" />

      <div style={{ position: 'absolute', top: '70px', left: '220px' }}><Card3 /></div>
      <div style={{ position: 'absolute', top: '70px', left: '480px' }}><Card4 /></div>
      <div style={{ position: 'absolute', top: '70px', left: '730px' }}><Card5 /></div>
      <div style={{ position: 'absolute', top: '70px', left: '980px' }}><Card6 /></div>

      {/* ── Graphique CLIENT : Montant livré & backlog ── */}
      <div style={{
        position: 'absolute', top: '240px', left: CONTENT_LEFT,
        width: `${CONTENT_WIDTH}px`,
        boxSizing: 'border-box',
        background: '#fff',
        border: '1px solid #e9ecef',
        borderRadius: '12px',
        padding: '16px',
      }}>
        <Graph5 width={CONTENT_WIDTH - 34} height={400} />
      </div>

      {/* ════════════════════════════════
          SECTION — STOCKS
      ════════════════════════════════ */}
      <SectionLabel label="Stocks" top="690px" />

      <div style={{ position: 'absolute', top: '720px', left: '320px' }}><Card7 /></div>
      <div style={{ position: 'absolute', top: '720px', left: '600px' }}><Card8 /></div>
      <div style={{ position: 'absolute', top: '720px', left: '880px' }}><Card9 /></div>

    </div>
  );
};

export default Home;